(function(){
  var infoText = document.querySelector(".usp-info-text");
  var modal = document.getElementById("usp-info-modal");
  if(!infoText || !modal) return;

  var closeBtn = modal.querySelector(".close");
  if(!closeBtn) return;

  infoText.addEventListener("click", function(){
    modal.style.display = "block";
  });

  closeBtn.addEventListener("click", function(){
    modal.style.display = "none";
  });

  window.addEventListener("click", function(event){
    if(event.target == modal){
      modal.style.display = "none";
    }
  });
})();